import React, { useState, useEffect } from 'react'
import LogRow from './LogRow'
import Api from '../../../services/Api'
import LoadingIcon from '../../formFields/LoadingIcon'

const SiteHistory = ({ siteId, powerAppId, powerAppSolutionId, powerAppEnvironmentId }) => {
    const [history, setHistory] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        getHistory()
    }, [])

    const getHistory = async () => {
        let query = ''
        if (siteId) {
            query = `siteId=${siteId}`
        } else if (powerAppId) {
            query = `powerAppId=${powerAppId}`
        } else if (powerAppSolutionId) {
            query = `powerAppSolutionId=${powerAppSolutionId}`
        } else if (powerAppEnvironmentId) {
            query = `powerAppEnvironmentId=${powerAppEnvironmentId}`
        }

        if (query) {
            setIsLoading(true)
            try {
                const url = `/siteHistory?${query}`
                const posts = await Api.get(url).then(res => res.data)
                setHistory(posts)
            } catch (error) {
                console.error(error)
            } finally {
                setIsLoading(false)
            }
        }
    }


    return (
        <div style={{ padding: '10px 0', minWidth: 500 }}>
            {   
                isLoading ? <LoadingIcon /> :
                history.map((x, index) => (
                    <LogRow
                        key={x.id}
                        even={index % 2 === 0}
                        changeDate={x.changeDate}
                        changeLog={x.changeLog}
                        user={x.user}
                    />
                ))
            }
        </div>
    )
}

export default SiteHistory



// WEBPACK FOOTER //
// ./src/components/Administration/SiteDetails/SiteHistory.js